import { render } from "./Tracking.vue?vue&type=template&id=9c4c3c6c&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"

import "./Tracking.vue?vue&type=style&index=0&id=9c4c3c6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9c4c3c6c"

export default script